import React from "react";
import {Card, CardHeader, CardContent, CardActions} from "@mui/material";

/**
 * LsCard
 *
 * Props:
 * title      string | ReactNode   (optional)
 * subheader  string | ReactNode   (optional)
 * action     ReactNode            (optional — top-right slot, e.g. icon button)
 * actions    ReactNode            (optional — footer action bar)
 * elevation  number               (default: 1 — pass 0 for flat/borderless)
 */
const LsCard = ({title, subheader, action, children, actions, elevation = 1, ...props}) => {
    return (
        <Card
            elevation={elevation}
            {...props}
            sx={{
                borderRadius: "6px",
                border: "1px solid",
                borderColor: "divider",
                boxShadow: elevation === 0 ? "none" : "0px 1px 2px rgba(0,0,0,0.05)",
                backgroundColor: "background.paper",
                ...props.sx,
            }}
        >
            {(title || action) && (
                <CardHeader
                    title={title}
                    subheader={subheader}
                    action={action}
                    sx={{
                        padding: "12px 16px",
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.default",
                        "& .MuiCardHeader-title": {
                            fontSize: "0.9375rem",
                            fontWeight: 600,
                            color: "text.primary",
                        },
                        "& .MuiCardHeader-subheader": {
                            fontSize: "0.75rem",
                            marginTop: "2px",
                        },
                    }}
                />
            )}

            <CardContent
                sx={{
                    padding: "16px",
                    "&:last-child": {paddingBottom: "16px"},
                }}
            >
                {children}
            </CardContent>

            {actions && (
                <CardActions
                    sx={{
                        padding: "12px 16px",
                        borderTop: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "background.default",
                    }}
                >
                    {actions}
                </CardActions>
            )}
        </Card>
    );
};

export default LsCard;